/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventdescriptionalsoen3Inputs */

const en_eventdescriptionalsoen3 = /** @type {(inputs: Eventdescriptionalsoen3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Also in English`)
};

const de_eventdescriptionalsoen3 = /** @type {(inputs: Eventdescriptionalsoen3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auch auf Englisch`)
};

/**
* | output |
* | --- |
* | "Also in English" |
*
* @param {Eventdescriptionalsoen3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventdescriptionalsoen3 = /** @type {((inputs?: Eventdescriptionalsoen3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventdescriptionalsoen3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventdescriptionalsoen3(inputs)
	return de_eventdescriptionalsoen3(inputs)
});
export { eventdescriptionalsoen3 as "eventDescriptionAlsoEn" }